import IconButton from '@mui/material/IconButton';
import { XLg } from 'react-bootstrap-icons';
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@mui/styles/styled';

const Container = styled('div')(({ theme }) => ({
	top: theme.spacing(3),
	right: theme.spacing(1.5),
}));

function DrawerCloseIcon({ onClose, ...props }) {
	return (
		<Container {...props}>
			<IconButton
				aria-label="close"
				aria-hidden="false"
				role="button"
				data-testid="drawer_close"
				onClick={onClose}
				sx={{
					fontSize: { xs: 20, sm: 28 },
				}}
			>
				<XLg style={{ fontWeight: '400' }} />
			</IconButton>
		</Container>
	);
}

DrawerCloseIcon.propTypes = {
	onClose: PropTypes.func.isRequired,
};

export default DrawerCloseIcon;
